<template>
  <div>
    <div @click="onPreviewClick" :class="`container${theModel.elementItem.ElementScale === 2 ? '4' :
    (theModel.elementItem.ElementScale === 1 ? '2' : '1')}table`">
      <!-- Превью отчёта. QueryTable рендерит lite-таблицу (QueryTableLite). -->

      <query-table :class="`preview${theModel.elementItem.ElementScale === 2 ? '4' :
      (theModel.elementItem.ElementScale === 1 ? '2' : '1')}table q-mt-md`"
        v-model="theModel.Element" :hide-panel="true"
        :src-element="theModel.elementItem"
        :paginationModel="paginationModel"
      />
    </div>
    <q-dialog maximized v-model="showFull" persistent fit>
      <q-card>
        <q-card-section class="row items-center">
          <div class="text-h6">{{ theModel.elementItem.Name }}</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-separator />
        <q-card-section style="max-height: 90vh; display: flex;" class="scroll">
          <query-table v-if="!querystore.isLoading" class="full-width"
            :is-in-dialog="true"
            v-model="theModel.Element"
            :src-element="theModel.elementItem"
            @update:paginationModel="onUpdatePagination"
            :paginationModel="paginationModel"
            :selectedEverything="theModel.selectedAll"
            @update:selectedEverything="onSelectedAllUpdate"
            :selectedEntities="theModel.selectedEntities"
            @update:selectedEntities="onSelectionUpdate"
            :unselectedEntities="theModel.unselectedEntities"
            @update:unselectedEntities="onUnSelectionUpdate"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>
  
<script lang="ts">
  import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
  import QueryTable from './QueryTable.vue';
  import { QueryResultItem } from '../base-list/interfaces/ListTypes';
import { queryStore } from '@/store/querytable';
  
  @Component({
    name: 'QueryTablePreview',
    components: {
      QueryTable
    }
  })
  export default class QueryTablePreview extends Vue {
    @Prop({ default: undefined })
    modelValue?: QueryResultItem
    @Emit("update:modelValue") emitModelValue(arg: any ) { return arg; }
    showFull: boolean = false

    querystore: any = undefined

    created() {
      this.querystore = queryStore()
    }

    async onPreviewClick() {
      this.showFull = true;
    }

    get theModel() {
      return this.modelValue
    }

    set theModel(arg: any) {
      this.emitModelValue(arg)
    }

    get paginationModel() {
      return this.theModel.pagination
    }

    onUpdatePagination(arg: any) {
      this.theModel.pagination = arg
    }

    onSelectedAllUpdate(arg: any) {
      this.theModel.selectedAll = arg
    }

    onSelectionUpdate(arg: any) {
      this.theModel.selectedEntities = arg
    }

    onUnSelectionUpdate(arg: any) {
      this.theModel.unselectedEntities = arg
    }
  }
</script>

<style lang="scss">

.container1table {
  float: left;
  width: calc(100% - 20px);
  min-width: calc(100% - 20px);
  max-width: calc(100% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container1table:hover {
  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container2table {
  float: left;
  width: calc(50% - 20px);
  min-width: calc(50% - 20px);
  max-width: calc(50% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container2table:hover {
  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container4table {
  float: left;
  width: calc(25% - 20px);
  min-width: calc(25% - 20px);
  max-width: calc(25% - 20px);
  height: 40vh;
  margin: 10px;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  display: block;
  border: 1px solid lightgrey;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightgrey 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.container4table:hover {
  &::after {
    content: ''; /* Выводим пустой блок */
    position: absolute; /* Абсолютное позиционирование */
    left: 0px; right: 0px; /* Устанавливает ширину блока */
    bottom: 0; /* Положение от нижнего края */
    height: 1em; /* Высота */
    background: linear-gradient(to bottom, transparent, lightblue 100%);
    pointer-events: none; /* Не реагирует на мышь */
  }
}

.preview1table {
  transform-origin: center;
  transform: translate(0, -10%) scale(0.8);
}

.preview2table {
  transform-origin: center;
  transform: translate(0, -10%) scale(0.8);
}

.preview4table {
  transform-origin: center;
  transform: translate(0, -25%) scale(0.5);
}

</style>